import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import Chip from '@ecp/common/src/components/chip/mo/Chip';
import { SwiperContents, SwiperContentsDefaultProps } from '@ecp/common/src/components/swiper/mo/SwiperTemplate';

const ChipItem = ({ item, itemProps }) => {
  const { onClick, onClose } = itemProps;
  return (
    <Chip
      closable={item?.closable}
      type={item?.type}
      data-value={item?.label}
      checked={item?.checked}
      onClick={() => onClick?.(item)}
      onClose={() => onClose?.(item)}
      ariaLabel={itemProps?.ariaLabel}
    >
      {item?.label}
    </Chip>
  );
};
ChipItem.propTypes = {
  item: PropTypes.object,
  itemProps: PropTypes.object,
};
const SwiperChip = ({ itemList, itemProps, width, ...props }) => (
  <Container width={width}>
    <SwiperContents
      itemList={itemList}
      itemComponent={ChipItem}
      itemProps={itemProps}
      carouselProps={{ ...SwiperContentsDefaultProps.carouselProps, spaceBetween: 6, slidesOffsetAfter: 28 }}
      {...props}
    />
  </Container>
);
export default SwiperChip;

SwiperChip.propTypes = {
  swiperRef: PropTypes.object,
  itemList: PropTypes.array,
  itemProps: PropTypes.object,
  width: PropTypes.string,
};

SwiperChip.displayName = 'SwiperChip';

const Container = styled(FlexBox)`
  overflow: scroll;
`;
